import { render } from "./ShenfYanzheng.vue?vue&type=template&id=5fab0794&scoped=true"
import script from "./ShenfYanzheng.vue?vue&type=script&lang=js"
export * from "./ShenfYanzheng.vue?vue&type=script&lang=js"

import "./ShenfYanzheng.vue?vue&type=style&index=0&id=5fab0794&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fab0794"]])

export default __exports__